import { Button, Spinner, Tooltip } from '@design-systems/canvas-ui'
import Icon, { DownloadIcon } from '@design-systems/react-icons'
import { faCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { PDFDownloadLink } from '@react-pdf/renderer'
import { CustomTooltip, getColor } from 'mvscommoncomponents'
import { RFI_TYPE_SUPPLIER } from '../../../../common/commonConstants'
import RFI2PdfGenerator from '../../../../globalComponents/Rfi2/Rfi2PdfGenerator'
import { formatStatusDate } from '../utils/dateUtils'

export default function StatusBar({
  isReadonly,
  rfiType,
  rfiObject,
  template,
  masterData,
  statusColorMapper,
}) {
  if (!isReadonly) return null

  const date = formatStatusDate(rfiObject?.vetting_status_updated_date)
  const rfi3Date = formatStatusDate(rfiObject?.rfi3_vetting_status_updated_date)

  const showPdf =
    rfiType?.toLowerCase() !== RFI_TYPE_SUPPLIER &&
    (rfiObject?.manufacturing_type_id === 27 ||
      rfiObject?.manufacturing_type_id === 10 ||
      rfiObject?.manufacturing_type_id === 8)

  const statusLabel =
    rfiType?.toLowerCase() === RFI_TYPE_SUPPLIER
      ? 'Status | RFI 1'
      : 'Status | RFI 2'

  return (
    <div className="rfi-status-bar hc8-bg-subdued">
      <div
        id="rfi-status-wrapper"
        className="rfi-status-wrapper hc8-ph-4x hc8-pv-2x"
      >
        <div className="rfi-pdf-download-button-wrapper">
          {showPdf && (
            <PDFDownloadLink
              document={
                <RFI2PdfGenerator
                  rfi3Data={rfiObject || {}}
                  rfi3Template={template || {}}
                  rfiMasterData={masterData || {}}
                />
              }
              fileName="RFI2-Form.pdf"
            >
              {({ loading }) =>
                loading ? (
                  <Spinner
                    key="spinner-rfi3-loading"
                    data-testid="spinner-rfi3-loading"
                    size="lg"
                  />
                ) : (
                  <CustomTooltip
                    title="Download as PDF"
                    placement="top"
                    arrow
                    component={
                      <Button
                        className="button-back hc8-ml-1x"
                        variant="ghost"
                        size="md"
                      >
                        <Icon svg={DownloadIcon} size="inline" aria-hidden />
                      </Button>
                    }
                  />
                )
              }
            </PDFDownloadLink>
          )}
        </div>

        <div className="rfi-status-content hc8-fs-100 hc8-clr-base">
          <span className="rfi-status-label hc8-mr-2x">{statusLabel}</span>

          {rfiObject?.vetting_status && (
            <span className="rfi-status-state">
              <FontAwesomeIcon
                icon={faCircle}
                className="rfi-status-dot hc8-mr-1x"
                color={getColor(rfiObject.vetting_status, statusColorMapper)}
              />
              <Tooltip content={date} location="top">
                <span>
                  {rfiObject.vetting_status.charAt(0).toUpperCase() +
                    rfiObject.vetting_status.slice(1).toLowerCase()}
                </span>
              </Tooltip>
            </span>
          )}

          {rfiObject?.rfi3_vetting_status && (
            <span className="rfi-status-rfi3 hc8-ml-2x">
              <span className="rfi-status-divider hc8-mr-2x" aria-hidden>
                |
              </span>
              <span className="hc8-mr-2x">RFI 3</span>
              <FontAwesomeIcon
                icon={faCircle}
                className="rfi-status-dot hc8-mr-1x"
                color={getColor(
                  rfiObject?.rfi3_vetting_status,
                  statusColorMapper,
                )}
              />
              <Tooltip content={rfi3Date} location="top">
                <span>
                  {(rfiObject?.rfi3_vetting_status || '')
                    .split(' ')
                    .map((s) => s.replace(/^./, (c) => c.toUpperCase()))
                    .join(' ')}
                </span>
              </Tooltip>
            </span>
          )}
        </div>
      </div>
    </div>
  )
}
